// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"d1d5b49d","881":"c48b5e63"}[chunkId] + ".chunk.js";
};